import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import moment from 'moment';

const useIndicatorsTop = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [indicatorList, setIndicatorList] = useState<any[]>();
  const [indicatorList2, setIndicatorList2] = useState<any[]>();
  const [indicatorList3, setIndicatorList3] = useState<any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  
  const { isLoading, refetch } = useQuery(
    [endpoints.management.indicators.top, [location.search]],
    () =>
      fetcher.management.postIndicatorTop({
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : moment().format('YYYY-01-01'),   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : moment().format('YYYY-12-31'),          
      }),
    {
      onSuccess: (res: indicatorListResDto) => {
        switch (res.code) {
          case 200:
            setIndicatorList(res.result?.list);
            setIndicatorList2(res.result?.list2);
            setIndicatorList3(res.result?.list3);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );


  return { indicatorList, indicatorList2, indicatorList3, refetch };
};

export default useIndicatorsTop;
